import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaInstagram, FaXTwitter, FaFacebook } from "react-icons/fa6";

const siteLogo = `${process.env.PUBLIC_URL}/img/Logo.png`;
const linkStyle = {
    display: "block",
    color: "#222",
    textDecoration: "none",
    marginBottom: "0px",
};

const Footer = () => {
    return (
        <footer
                style={{
                    background: "#fff",
                    borderTop: "1px solid #eee",
                    marginTop: "50px",
                    padding: "40px 0 10px",
                }}
            >
                <Container>
                    <Row className="align-items-center mb-4">
                        <Col md={6} className="d-flex align-items-center gap-4 mb-3 mb-md-0">
                            <img
                                src={siteLogo}
                                alt="logo"
                                style={{ height: "90px" }}
                            />
                            <div>
                                <p style={{ margin: 0, color: "#555", fontWeight: 500 }}>
                                    ProudTapi News brings latest updates from Gujarat, India and around the world.
                                </p>
                                <div style={{ marginTop: "10px", fontSize: "14px", color: "#444" }}>
                                    <p style={{ marginBottom: "10px" }}>
                                        <strong>Email:</strong><br />
                                        <a href="mailto:proudtapinews@gmail.com" style={{ color: "#0d6efd", textDecoration: "none" }}>
                                            proudtapinews@gmail.com
                                        </a>
                                    </p>
                                    <p style={{ marginBottom: "10px" }}>
                                        <strong>Contact:</strong><br />
                                        <a href="tel:8000930590" style={{ color: "#0d6efd", textDecoration: "none" }}>
                                            +91 8000930590
                                        </a>
                                    </p>
                                    <p style={{ marginBottom: 0 }}>
                                        <strong>Office Address:</strong><br />
                                        Head Office First floor, Shalin Centrum, Near Croma, Sector 11, Gandhinagar, Gujarat
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col md={6} className="d-flex justify-content-md-end justify-content-center">
                            <nav style={{ width: "100%" }}>
                                <ul style={{
                                    display: "flex",
                                    gap: "40px",
                                    listStyle: "none",
                                    padding: 0,
                                    margin: 0,
                                    fontWeight: 500,
                                    fontSize: "18px"
                                }}>
                                    <li><Link to="/" style={linkStyle}>Home</Link></li>
                                    <li><Link to="/special" style={linkStyle}>ProudTaapi Special</Link></li>
                                    <li><Link to="/top-news" style={linkStyle}>Top News</Link></li>
                                    <li><Link to="/epaper" style={linkStyle}>E-Paper</Link></li>
                                </ul>
                            </nav>
                        </Col>
                    </Row>
                    <hr />
                    {/* SOCIAL ICONS */}
                    <Row className="mb-3">
                        <Col>
                            <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                                <a href="https://wa.me/8000930590" target="_blank" rel="noreferrer">
                                    <FaWhatsapp size={20} color="green" />
                                </a>
                                <a href="https://www.instagram.com/proud_tapi_news" target="_blank" rel="noreferrer">
                                    <FaInstagram size={20} color="#E1306C" />
                                </a>
                                <a href="https://x.com/ProudTapi" target="_blank" rel="noreferrer">
                                    <FaXTwitter size={20} />
                                </a>
                                <a href="https://www.facebook.com/share/1CfZwrWSsH/" target="_blank" rel="noreferrer">
                                    <FaFacebook size={20} color="#1877F2" />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    {/* COPYRIGHT */}
                    <div style={{ textAlign: "center", borderTop: "1px solid #eee", paddingTop: "10px" }}>
                        <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
                            © {new Date().getFullYear()} ProudTapi News. All Rights Reserved.
                        </p>
                        <p style={{ margin: "4px 0", fontSize: "14px" }}>
                            Developed by{" "}
                            <a href="https://www.dreamitinfotech.in/" target="_blank" rel="noopener noreferrer" style={{ color: "#0d6efd", fontWeight: 600, textDecoration: "none" }}>
                                Dreamit Infotech Pvt. Ltd.
                            </a>
                        </p>
                    </div>
                </Container>
            </footer>
        );
    };

    export default Footer;